__turbopack_context__.v({
  "bredCrumbs_block": "page-module-scss-module__rTSwya__bredCrumbs_block",
  "infraSvg": "page-module-scss-module__rTSwya__infraSvg",
  "infraSvgMobFive": "page-module-scss-module__rTSwya__infraSvgMobFive",
  "landscapingPageButtonWrapper": "page-module-scss-module__rTSwya__landscapingPageButtonWrapper",
  "parallaxContainer": "page-module-scss-module__rTSwya__parallaxContainer",
  "svgClassFifth": "page-module-scss-module__rTSwya__svgClassFifth",
  "svgClassMobFive": "page-module-scss-module__rTSwya__svgClassMobFive",
});
